import api from "../services/api";

// Service to fetch all privacy settings
export const fetchPrivacySettings = async () => {
  try {
    const response = await api.get("/privacy-settings-management/all");

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected response while fetching privacy settings:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching privacy settings:", error.message || error);
    return { success: false, error: error.message || "Failed to fetch privacy settings" };
  }
};
